module.exports = "/assets/7635b2709d377c245febf8dae22e759b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/MA.png
// module id = 2731
// module chunks = 0